<template>
  <a-modal title="查看报表" :width="900" :visible="visible" :maskClosable="false" :footer="null" v-if="hackReset"
    @cancel="handleCancel">
    <div>
      <a-row :gutter="24">
        <a-col :md="6" :sm="12">
          <a-form-item label="年度" :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 6 }}">
            <a-select v-model="queryParam.year" style="width:120px" allow-clear placeholder="请选择年度" :options="yearArr">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item label="月份" :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 6 }}">
            <a-select v-model="queryParam.month" style="width:120px" allow-clear placeholder="请选择月份"
              :options="monthArr"></a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item label="科室" :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 6 }}">
            <a-select v-model="queryParam.deptCode" style="width:120px" allow-clear placeholder="请选择科室"
              :options="deptArr"></a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        </a-col>

      </a-row>

    </div>
    <div>
      <s-table ref="table" :columns="columns" :data="loadData" :rowKey="(record) => record.time" :pageSize="50">
      </s-table>
      <div class="totalPrice">
        <a-row style="height:30px;line-height:30px;text-align: center;padding-right: 20px;">
          <a-col :span="4" style="padding-left:5px">
            <label>合计：</label>
          </a-col>
          <a-col :span="4" style="padding-left:15px">
            <label>{{ this.loadUser.image}}</label>
          </a-col>
          <a-col :span="4" style="padding-right:14px">
            <label>{{ this.loadUser.video}}</label>
          </a-col>
          <a-col :span="4" style="padding-right:40px">
            <label>{{ this.loadUser.consult}}</label>
          </a-col>
          <a-col :span="4" style="padding-right:40px">
            <label>{{ this.loadUser.all}}</label>
          </a-col>
          <a-col :span="4">
            <label>{{ this.loadUser.money}}</label>
          </a-col>
        </a-row>
      </div>
    </div>

  </a-modal>
</template>

<script>
  import { STable } from '@/components';
  import moment from 'moment'
import { statisticsDept, statisticsList } from '@/api/modular/interhospital/statistics/statisticsMange'
  export default {
    components:{
      STable
    },
    data () {
      return {
        // 科室
        deptArr : [],
        //年度
        yearArr: [],
        // 月份
        monthArr: [
          {
            label: '1月',
            value: '01'
          },
          {
            label: '2月',
            value: '02'
          },
          {
            label: '3月',
            value: '03'
          },
          {
            label: '4月',
            value: '04'
          },
          {
            label: '5月',
            value: '05'
          },
          {
            label: '6月',
            value: '06'
          },
          {
            label: '7月',
            value: '07'
          },
          {
            label: '8月',
            value: '08'
          },
          {
            label: '9月',
            value: '09'
          },
          {
            label: '10月',
            value: '10'
          },
          {
            label: '11月',
            value: '11'
          },
          {
            label: '12月',
            value: '12'
          },
        ],
        // 
        queryParam: {
          deptCode: '',
          month: ( new Date().getMonth() + 1),
          year: new Date().getFullYear(),
          pageSize: 50,
          pageNo : 1
        },
        visible: false,
        hackReset : true,

        loadUser : [],
        loadData:  parameter => {
          return  new Promise(async(resolve,reject)=>{
            const res = await statisticsList(this.queryParam);
            console.log(res)
              this.loadUser = res.data;
              resolve(res.data.list);
          });
        },
        columns : [
          {
              title: '就诊日期',
              align: 'center',
              dataIndex: 'time',
              width : 152
            },
            {
              title: '图文问诊',
              align: 'center',
              dataIndex: 'image',
            },
            {
              title: '视频问诊',
              align: 'center',
              dataIndex: 'video'
            },
            {
              title: '健康咨询',
              align: 'center',
              dataIndex: 'consult'
            },
            {
              title: '全部问诊量',
              align: 'center',
              dataIndex: 'all'
            },
            {
              title: '全部问诊金额',
              align: 'center',
              dataIndex: 'money'
            },
        ],
      }
    },
    methods: {
      moment,
      // 年度下拉框
      intYear() {
        let year = new Date().getFullYear();
        for (var i = 3; i--; i >= 0){
          this.yearArr.push({
            label: year + '年',
            value: year
          })
          year--
        }
      },
      // 初始化方法
      add() {
        this.loadUser = [];
        this.visible = true;
        this.intYear();
        this.getDept();
      },

      //点击取消按钮
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      // 修改日期
      changeYear(date,dateString) {
        
      },

      // 获取科室
      getDept() {
        statisticsDept().then(res => {
          if (res.code == 200) {
            res.data.forEach((item, index) => {
              res.data[index] = {
                label: item.deptName,
                value: item.deptCode
              }
            });
            this.deptArr = res.data;
            this.deptArr.unshift({
              label: '全部科室',
              value : ''
            })
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
/deep/.s-table-tool{
  display: none;
}
.totalPrice{
  line-height: 30px;
}
.detialImage{
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  
  // transform: rotate();
}
</style>
